module.exports = __webpack_public_path__ + "static/media/bouche-federico.381f915b.jpg";